<template>
	<label 
		:for="fieldKey"
		:class="fieldClass"
		class="login-panel__field" 
	>
		<div class="login-panel__label">{{ field_label }}</div>

		<p 
			v-if="field_description"
			class="login-panel__description"
		>{{ field_description }}</p>

		<input 
			@input="handleInput"
			:value="input.value"
			:type="activeFieldType"
			:id="fieldKey"
			:name="fieldKey"
			:class="inputClass"
			class="login-panel__input" 
		/>

		<!-- <div 
			v-if="error_msg"
			class="login-panel__error-msg"
		>{{ error_msg }}</div> -->

		<button 
			v-if="'password' === field_type"
			@click.prevent="toggleShowPassword"
			:class="{ 'is-toggled': showPassword }"
			class="login-panel__field__password-toggle"
			type="button"
		>
			<i 
				:class="{ 'icon-visibility': showPassword }"
				class="show-password-icon icon icon-invisible"
			></i>
		</button>

		<ul
			v-if="field_validate_password"
			class="login-panel__field__validation"
		>
			<li 
				:class="{ 'is-valid': this.errorPassword.length }"
				class="login-panel__field__validation__rule"
			>At least 10 characters</li>
			<li 
				:class="{ 'is-valid': this.errorPassword.hasNumber }"
				class="login-panel__field__validation__rule"
			>At least 1 number</li>
			<li 
				:class="{ 'is-valid': this.errorPassword.hasSymbol }"
				class="login-panel__field__validation__rule"
			>At least 1 special character</li>
		</ul>

		<div 
			v-if="errorMsg"
			class="login-panel__field__error"
		>{{ errorMsg }}</div>

	</label>
</template>


<script>
	import InputValidator from '../helpers/InputValidator.mjs'

	export default {
		name: 'LoginInputField',
		props: {
			input: {
				type: 		Object,
				required: 	true,
			},

			field_type: {
				type: 		String,
				default: 	'text',
			},

			field_label: {
				type: 		String,
				required: 	true,
			},

			field_description: {
				type: 		String,
				default: 	'',
			},

			field_validate_password: {
				type: 		Boolean,
				default: 	false,
			}
		},


		data() {
			return {
				activeFieldType: 	this.field_type,
				checkInputInterval:	null,
				errorMsg: 			'',
				errorPassword: 		{},
				showPassword: 		false,
			}
		},


		beforeMount() {
			if( this.field_validate_password ) {
				this.errorPassword = {
					hasNumber: 	false,
					hasSymbol: 	false,
					length: 	false,
				}
			}
		},


		computed: {
			fieldKey() {
				return this.field_label.replace( /[\W_]+/g, '' )
			},

			fieldClass() {
				return `login-panel__field--${this.field_type}`
			},

			inputClass() {
				const classes = new Set()

				classes.add( `login-panel__input--${this.field_type}` )
				
				if( this.errorMsg.length ) {
					classes.add( 'login-panel__input--invalid' )
				} else {
					classes.delete( 'login-panel__input--invalid' )
				}

				return Array.from( classes ).join( ' ' )
			},
		},


		methods: {
			toggleShowPassword() {
				if( 'password' === this.field_type ) {
					this.showPassword 		= !this.showPassword
					this.activeFieldType 	= this.showPassword ? 'text' : 'password'
				}
			},


			// passwordParamIsValid( key ) {
			// 	const classes = {
			// 		'is-valid': 	null,
			// 		'is-invalid': 	null
			// 	}

			// 	if( Object.prototype.hasOwnProperty.call( this.errorPassword, key ) ) {
			// 		const isValid = this.errorPassword[ key ]

			// 		classes['is-valid'] = isValid
			// 		classes['is-invalid'] = !isValid
			// 	}

			// 	return classes
			// },			


			handleInput( e ) {
				const self	= this,
					value	= e.target.value.trim()

				this.input.value = value

				clearTimeout( self.checkInputInterval )
				self.checkInputInterval = setTimeout( self.validateInput, 2000 )
			},


			validateInput() {
				const value = this.input.value

				// validation for passwords
				if( 'password' === this.field_type /* && this.field_validate_password */ ) {
					this.validatePassword( value )
				
				// validation for email
				} else if( 'email' === this.field_type ) {
					this.validateEmail( value )
				
				// validation for generic text
				// todo — improve
				} else {

					// names should be at least two characters
					if( 'First Name' === this.field_label || 'Last Name' === this.field_label ) {
						this.validateNamePart( value )
					} else {

						// todo — obviously, this isn't ideal
						this.input.isValid = true
					}
				}
			},


			checkIfValid() {

				// force-validate immediately
				clearTimeout( self.checkInputInterval )
				this.validateInput()

				return this.input.isValid
			},


			validatePassword( value ) {
				if( 2 <= value.length ) {
					this.input.isValid = true
					this.errorMsg = ''
				} else {
					this.input.isValid = false
					this.errorMsg = `Please enter your ${this.field_label}`
				}

				// todo — doesn't match WordPress's password requirements; maybe use wpStrengthMeter
				/* const { length = false, hasNumber = false, hasSymbol = false } = InputValidator.isValidPassword( value )

				// password has special error messages
				this.errorPassword = {
					hasNumber,
					hasSymbol,
					length,
				}

				this.input.isValid = ( length && hasNumber && hasSymbol ) */
			},


			validateEmail( value ) {
				this.input.isValid = InputValidator.isValidEmail( value )

				if( this.input.isValid ) {
					this.errorMsg = ''
				} else {
					this.errorMsg = 'Please enter a valid email address.'
				}
			},


			validateNamePart( value ) {

				// check that name part has at least two characters
				if( 2 <= value.length ) {
					this.input.isValid = true
					this.errorMsg = ''
				} else {
					this.input.isValid = false
					this.errorMsg = `Your ${this.field_label} must be at least 2 characters long`
				}
			}

		},	

	}
</script>